import { type MouseEventHandler, useId } from 'react';
import classes from './RainbowButton.module.css';
import type { Props } from './RainbowButton.types';

export const RainbowButton = ({ id, onClick, children, ...props }: Props) => {
  const randomId = useId();
  const rootId = id || randomId;

  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick?.(event);
  };

  return (
    <div className={classes.wrap} id={rootId}>
      <button onClick={handleButtonClick} type="button" {...props}>
        <span />
        <span />
        <span />
        <span>{children}</span>
      </button>
    </div>
  );
};
